import { combineReducers } from 'redux';
// slices
import authReducer from './slices/auth';
import documentReducer from './slices/document';
import onboardingReducer from './slices/onboarding';
import tourReducer from './slices/tour';

// ----------------------------------------------------------------------

const rootReducer = combineReducers({
  auth: authReducer,
  document: documentReducer,
  onboarding: onboardingReducer,
  tour: tourReducer,
});

export { rootReducer };
